module.exports = __webpack_public_path__ + "assets/img/caseS.0ce77a10.png";